import './Block.scss'

interface IProps{
    children: any;
}
export default function Block({children}: IProps){
    return <div className="block">
        {children}
    </div>
}